<template>
    <div class="form-field form-autocomplete" :rel="name" v-bind:class="{'form-required': requiredForm}">
        <div class="form-label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">
                <component-multiselect v-model="internalValue"
                                   :show-labels="false"
                                   label="name"
                                   track-by="id"
                                   placeholder="Type to search"
                                   :options="data"
                                   :multiple="isMultiple"
                                   :searchable="true"
                                   :loading="isLoading"
                                   :internal-search="false"
                                   :clear-on-select="true"
                                   :options-limit="300"
                                   :limit="3"
                                   :limit-text="limitText"
                                   :max-height="600"
                                   :show-no-results="false"
                                   :hide-selected="true"
                                   @search-change="asyncFind">
                    <template slot="clear" slot-scope="props">
                        <div class="multiselect__clear" v-if="internalValue" @mousedown.prevent.stop="clearAll(props.search)"></div>
                    </template><span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
                </component-multiselect>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormField',
        props: ['value','label','name','placeholder','multiple', 'default','id','service','update','required'],
        data: function () {
            return {
                internalValue: '',
                data: [],
                isLoading: false
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.isMultiple = this.multiple == 'true' ? true : false;
            this.requiredForm = this.required && this.required == 'true' ? true : false
        },
        methods: {
            limitText (count) {
                return `and ${count} other countries`
            },
            asyncFind (query) {
                this.service.all('?query=' + query ).then(response => {
                    this.data = response.data.data ? response.data.data : response.data
                    console.log("DATA", this.data)
                })
            },
            clearAll () {
                this.internalValue = []
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'default'(newVal, oldVal) {
                for (let item of this.options) {
                    if( item.id.toString().toLowerCase() == newVal.toString().toLowerCase() ){
                        this.internalValue = item;
                    }
                }
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Autocomplete.vue